module.exports = __webpack_public_path__ + "media/images/general/brands/amex-d77def114e70a96675da97d2c3e620b1.png";